var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkSessions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#0076FE",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 23.7446C35.672 23.7446 35 23.0726 35 22.2446V19.9946H29V22.2446C29 23.0726 28.328 23.7446 27.5 23.7446C26.672 23.7446 26 23.0726 26 22.2446V19.9946C26 18.3401 27.3455 16.9946 29 16.9946H35C36.6545 16.9946 38 18.3401 38 19.9946V22.2446C38 23.0726 37.328 23.7446 36.5 23.7446Z",
    fill: "#0076FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.065 37.0599C32.795 37.1649 32.405 37.2399 32 37.2399C31.595 37.2399 31.205 37.1649 30.845 37.0299L14 31.4199V42.8649C14 45.1449 15.845 46.9899 18.125 46.9899H45.875C48.155 46.9899 50 45.1449 50 42.8649V31.4199L33.065 37.0599Z",
    fill: "#0076FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 25.6196V29.0546L32.36 34.9346C32.24 34.9796 32.12 34.9946 32 34.9946C31.88 34.9946 31.76 34.9796 31.64 34.9346L14 29.0546V25.6196C14 23.3396 15.845 21.4946 18.125 21.4946H45.875C48.155 21.4946 50 23.3396 50 25.6196Z",
    fill: "#0076FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkSessions);
export default __webpack_public_path__ + "static/media/work-sessions.43101a739ef6624422e7d77efb2c5061.svg";
export { ForwardRef as ReactComponent };